<template>
  <transition name="roll">
    <slot />
  </transition>
</template>


<script>
export default {
  name: "RollTransition",
};
</script>

<style scoped>
.roll-enter-active,
.roll-leave-active {
  transition: all 0.2s ease-out;
  max-height: 100px;
  height: auto;
  overflow: hidden;
}
.roll-enter,
.roll-leave-to {
  max-height: 0;
}
</style>
